import { withNamespace } from "@/i18n/lazy-route"

/** The finance exports (LLD §9.23, Task 6.5), with the `adminReports` namespace. */
export const ReportsScreen = withNamespace(
  "adminReports",
  () => import("./screens/ReportsScreen"),
  {
    en: () => import("@/i18n/locales/en/adminReports.json"),
    fr: () => import("@/i18n/locales/fr/adminReports.json"),
  },
)
